export default __webpack_public_path__ + "static/retail-insta-video-0f3078f5d951ce77c64050f030ac0caa.gif";